import _ from 'lodash';
import moment from 'moment';
import marketCalendarService from '../../../core/services/Market/MaketCalendar/WatchListService';
import corpotateService from '../../../core/services/Market/MaketCalendar/CorporateService';
import economyService from '../../../core/services/Market/MaketCalendar/EconomyService';
import { NEW_LISTING, OTHER_LISTING } from './Const';
import CorporateConst from './corporate/Const';
import Const from './watchlist/Const';
import ConstEconomy from './economy/Const';
import { REDUCER_NAME as REDUCER_NAME_WL } from '../watchlist/reducer';
import {
  getDataFollowKeyByDot,
  getUnique,
  uniqueNumber,
} from './../../helpers/Common';
import reducerRegistry from './../../helpers/ReducerRegistry';
import Interval from '../../helpers/IntervalCallApi';
import ConstCommon from './../../common/Const';
import currentState from './../../helpers/CurrentState';
import { formatDate } from '../../helpers/FormatDate';

const REDUCER_NAME = 'MARKET_CALENDAR:';
const FETCH_LIST_WATCH_LIST = `${REDUCER_NAME}FETCH_LIST_WATCH_LIST`;
const CHANGE_FILTER_EVENT = `${REDUCER_NAME}CHANGE_FILTER_EVENT`;
const CHANGE_TIME_RANGE = `${REDUCER_NAME}CHANGE_TIME_RANGE`;
const FETCH_LIST_CORPORATE = `${REDUCER_NAME}FETCH_LIST_CORPORATE`;
const CHANGE_CODE = `${REDUCER_NAME}CHANGE_CODE`;
const FETCH_LIST_WATCH_LIST_DROP = `${REDUCER_NAME}FETCH_LIST_WATCH_LIST_DROP`;
const CHANGE_TAB = `${REDUCER_NAME}CHANGE_TAB`;
const CHANGE_WATCH_LIST = `${REDUCER_NAME}CHANGE_WATCH_LIST`;
const CHANGE_GET_DATA = `${REDUCER_NAME}CHANGE_GET_DATA`;
const SET_DATE_RANGE_OPTION = `${REDUCER_NAME}SET_DATE_RANGE_OPTION`;
const SET_FILTER_NEW_VALUE = `${REDUCER_NAME}SET_FILTER_NEW_VALUE`;
const LOAD_MORE_WATCH_LIST = `${REDUCER_NAME}LOAD_MORE_WATCH_LIST`;
const SET_FETCHING = `${REDUCER_NAME}SET_FETCHING`;
const FETCH_DATA = `${REDUCER_NAME}FETCH_DATA`;
const SET_QUERY_NEW_VALUE = `${REDUCER_NAME}SET_QUERY_NEW_VALUE`;

const CHANGE_EVENT_TYPE = `${REDUCER_NAME}CHANGE_EVENT_TYPE`;
const FETCH_LIST_WATCH_LIST_DATE = `${REDUCER_NAME}FETCH_LIST_WATCH_LIST_DATE`;
const CHANGE_FLAG = `${REDUCER_NAME}CHANGE_FLAG`;
const LOAD_MORE_DIV_CORPORATE = `${REDUCER_NAME}LOAD_MORE_DIV_CORPORATE`;
const FETCH_DATA_CORPORATE = `${REDUCER_NAME}FETCH_DATA_CORPORATE`;
const RESET_DATE_RANGE_OPTION = `${REDUCER_NAME}RESET_DATE_RANGE_OPTION`;
// economy
const FETCH_LIST_ECONOMY = `${REDUCER_NAME}FETCH_LIST_ECONOMY`;
const SET_FILTER_ECONOMY_VALUE = `${REDUCER_NAME}SET_FILTER_ECONOMY_VALUE`;
const LIST_ECO_BY_CHECKBOX = `${REDUCER_NAME}LIST_ECO_BY_CHECKBOX`;
const SET_ACTIVE_DAY_IN_WEEK = `${REDUCER_NAME}SET_ACTIVE_DAY_IN_WEEK`;
const SET_PARAMS_ECO = `${REDUCER_NAME}SET_PARAMS_ECO`;
const FETCH_DATA_ECO = `${REDUCER_NAME}FETCH_DATA_ECO`;
const SET_ACTIVE_DAY_IN_WEEK_CHANGE_TAB = `${REDUCER_NAME}SET_ACTIVE_DAY_IN_WEEK_CHANGE_TAB`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const SET_DATA_LISTING = `${REDUCER_NAME}SET_DATA_LISTING`;
const LOAD_MORE_NEW_LISTING = `${REDUCER_NAME}LOAD_MORE_NEW_LISTING`;
const LOAD_MORE_OTHER_LISTING = `${REDUCER_NAME}LOAD_MORE_OTHER_LISTING`;

const WEEK = 'isoweek';
const MONTH = 'month';

export {
  REDUCER_NAME,
  changeFilterEvent,
  changeTimeRange,
  fetchListDataTable,
  changeTab,
  fetchListWatchListDropDown,
  changeGetData,
  setDateRangeOption,
  setFilterNewValue,
  changeCode,
  loadMoreWatchList,
  setQueryNewValue,
  changeEvenType,
  changeWatchListDropDown,
  cancelIntervalFetchWatchList,
  intervalFetchWatchList,
  loadMoreCorporateDiv,
  // Economy
  intercalFetchEconomy,
  cancelIntervalFetchEconomy,
  setActiveDayInWeek,
  setParamsEco,
  setActiveDayInWeekChangeTab,
  resetDateRangeOption,
  loadMoreListing,
};

// ===================start economy
function intercalFetchEconomy(item) {
  return (dispatch, getState) => {
    const store = getState();
    let params = {
      WeekOfYear: store[REDUCER_NAME].weekOfYear,
      Year: store[REDUCER_NAME].year,
      Page: item.page,
      PageSize: item.pageSize,
      KeyWord: store[REDUCER_NAME].keyWordEconomy
        ? store[REDUCER_NAME].keyWordEconomy
        : '',
    };
    Interval.fetch(
      'Economy',
      dispatch,
      function(source) {
        return economyService.getListEconomy(params, source);
      },
      function(response) {
        const { items = [] } = response.items === null ? [] : response;
        const newItems = items.map((item, index) => ({
          ...item,
          sortOrder: index + 1,
        }));
        dispatch({
          type: FETCH_LIST_ECONOMY,
          payload: {
            listEconomy: newItems,
            totalCount: response.totalCount,
            pageSize: ConstEconomy.pageSize,
          },
        });
      },
      1000 * 60 * 5,
    );
  };
}

function cancelIntervalFetchEconomy() {
  return () => {
    Interval.cancel('Economy');
  };
}

function setActiveDayInWeek(params) {
  return dispatch => {
    dispatch({
      type: SET_ACTIVE_DAY_IN_WEEK,
      payload: {
        activeStatus: params.activeStatus,
        currentWeek: params.currentWeek,
        position: params.position,
        filterDate: params.filterDate,
      },
    });
  };
}

function setActiveDayInWeekChangeTab() {
  return dispatch => {
    dispatch({
      type: SET_ACTIVE_DAY_IN_WEEK_CHANGE_TAB,
      payload: {
        activeStatus: true,
      },
    });
  };
}

function setParamsEco(params) {
  return dispatch => {
    dispatch({
      type: SET_PARAMS_ECO,
      payload: {
        weekOfYear: params.weekOfYear,
        year: params.year,
        keyWord: params.keyWord,
        Page: ConstEconomy.page,
        PageSize: ConstEconomy.pageSize,
      },
    });
  };
}

function cancelIntervalFetchWatchList() {
  return () => {
    Interval.cancel('WatchList');
  };
}

function intervalFetchWatchList(
  eventType,
  watchlistType,
  watchListId,
  fromPublicDate,
  toPublicDate,
  fromExrightDate,
  toExrightDate,
  fromRecordDate,
  toRecordDate,
  fromExerciseDate,
  toExerciseDate,
) {
  return dispatch => {
    Interval.fetch(
      'WatchList',
      dispatch,
      function(source) {
        const params = { Page: 1, PageSize: 50 };
        if (eventType) {
          params.Type = eventType !== 'IPO' ? eventType : 'LIS';
        }
        if (watchlistType) params.WatchlistType = watchlistType;
        if (watchListId) params.WatchListId = watchListId.toString();
        if (fromPublicDate) params.FromPublicDate = fromPublicDate;
        if (toPublicDate) params.ToPublicDate = toPublicDate;
        if (fromExrightDate) params.FromExrightDate = fromExrightDate;
        if (toExrightDate) params.ToExrightDate = toExrightDate;
        if (fromRecordDate) params.FromRecordDate = fromRecordDate;
        if (toRecordDate) params.ToRecordDate = toRecordDate;
        if (fromExerciseDate) params.FromExerciseDate = fromExerciseDate;
        if (toExerciseDate) params.ToExerciseDate = toExerciseDate;
        return marketCalendarService.getListWatchList(params, source);
      },
      function(response) {
        const { items = [] } = response || {};

        dispatch({
          type: FETCH_LIST_WATCH_LIST,
          payload: {
            lstWatchList: items,
            totalCount: response.totalCount,
            pageSize: 50,
          },
        });
      },
      1000 * 60 * 5,
    );
  };
}

function loadMoreWatchList(params) {
  return (dispatch, getState) => {
    const store = getState();
    const flag = store[REDUCER_NAME].checkFlag;
    const formatParams = formatedParams(params, flag);
    dispatch(setFetching());
    marketCalendarService.getListWatchList(formatParams).then(response => {
      dispatch(setFetching(false));
      const { items = [] } = response.items === null ? [] : response;
      if (!items) return;
      dispatch({
        type: LOAD_MORE_WATCH_LIST,
        payload: {
          listWatchListLoadMore: items || [],
          pageNumber: params.Page,
        },
      });
    });
    dispatch({
      type: FETCH_DATA,
      payload: {
        isFetching: true,
      },
    });
  };
}

function changeEvenType(eventType) {
  return (dispatch, getState) => {
    const store = getState();
    const watchListId = store[REDUCER_NAME].watchListId;
    const watchlistType = store[REDUCER_NAME].watchlistType;

    dispatch({
      type: CHANGE_EVENT_TYPE,
      payload: {
        eventType,
        watchListId,
        watchlistType,
        checkFlag: 1,
      },
    });

    const eventTypeCustom = eventType !== 'IPO' ? eventType : 'LIS';

    dispatch(
      intervalFetchWatchList(eventTypeCustom, watchlistType, watchListId),
    );
  };
}

function changeWatchListDropDown(watchlistType, watchListId) {
  return (dispatch, getState) => {
    const store = getState();
    let eventType = store[REDUCER_NAME].eventType;
    dispatch({
      type: CHANGE_WATCH_LIST,
      payload: {
        watchlistType,
        watchListId,
        eventType,
        checkFlag: 2,
      },
    });
  };
}

function fetchData(dispatch, currentTab) {
  if (currentTab === 1) {
  }
  if (currentTab === 2) {
    dispatch(intervalFetchWatchList());
  }
  if (currentTab === 3) {
  }
}

function changeGetData(
  fromPublicDate,
  toPublicDate,
  fromExrightDate,
  toExrightDate,
  fromRecordDate,
  toRecordDate,
  fromExerciseDate,
  toExerciseDate,
) {
  return (dispatch, globalState) => {
    const store = globalState();
    const watchListId = store[REDUCER_NAME].watchListId;
    const watchlistType = store[REDUCER_NAME].watchlistType;
    let eventType = store[REDUCER_NAME].eventType;
    dispatch({
      type: CHANGE_GET_DATA,
      payload: {
        fromPublicDate,
        toPublicDate,
        fromExrightDate,
        toExrightDate,
        fromRecordDate,
        toRecordDate,
        fromExerciseDate,
        toExerciseDate,
        checkFlag: 3,
      },
    });
    dispatch(
      intervalFetchWatchList(
        eventType,
        watchlistType,
        watchListId,
        fromPublicDate,
        toPublicDate,
        fromExrightDate,
        toExrightDate,
        fromRecordDate,
        toRecordDate,
        fromExerciseDate,
        toExerciseDate,
      ),
    );
  };
}

function setFetching(payload = true) {
  return {
    type: SET_FETCHING,
    payload,
  };
}

const FLAGS = {
  EVENT_TYPE: 1,
  WATCH_LIST: 2,
  TO_DATE: 3,
};

function formatedParams(params, flag) {
  const formatParams = {
    Page: params.Page || 1,
    PageSize: params.PageSize || 50,
  };
  if (params.eventType) formatParams.Type = params.eventType;
  if (params.watchlistType) formatParams.WatchlistType = params.watchlistType;
  if (params.watchListId) formatParams.WatchListId = params.watchListId;

  if (flag === FLAGS.TO_DATE) {
    if (params.fromPublicDate) {
      formatParams.FromPublicDate = formatDate(params.fromPublicDate, true);
    }
    if (params.toPublicDate)
      formatParams.ToPublicDate = formatDate(params.toPublicDate, false);
    if (params.fromExrightDate)
      formatParams.FromExrightDate = formatDate(params.fromExrightDate, true);
    if (params.toExrightDate)
      formatParams.ToExrightDate = formatDate(params.toExrightDate, false);
    if (params.fromRecordDate)
      formatParams.FromRecordDate = formatDate(params.fromRecordDate, true);
    if (params.toRecordDate)
      formatParams.ToRecordDate = formatDate(params.toRecordDate, false);
    if (params.fromExerciseDate)
      formatParams.FromExerciseDate = formatDate(params.fromExerciseDate, true);
    if (params.toExerciseDate)
      formatParams.ToExerciseDate = formatDate(params.toExerciseDate, false);
  }

  return formatParams;
}

function setQueryNewValue(queryNews) {
  return dispatch => {
    dispatch({
      type: SET_QUERY_NEW_VALUE,
      payload: {
        queryNews,
      },
    });
  };
}

function formatedParamsCorporate(params, ticker, dateRangeOption) {
  let { Page, PageSize } = params;
  let { OrganCode } = ticker || '';
  let { FromDate, ToDate } = dateRangeOption;

  const formatParams = {
    OrganCode: '',
    Page: 1,
    PageSize: 50,
  };
  if (OrganCode) formatParams.OrganCode = OrganCode;
  if (FromDate) {
    formatParams.FromDate = formatDate(FromDate, true);
  }
  if (ToDate) {
    formatParams.ToDate = formatDate(ToDate, true);
  }
  if (Page) formatParams.Page = Page;
  if (PageSize) formatParams.PageSize = PageSize;
  return formatParams;
}

function getFormatParamByFilterSearch(ticker, dateRangeOption) {
  const params = { OrganCode: ticker || '' };

  return formatedParamsCorporate({}, params, dateRangeOption);
}

function loadMoreListing(params) {
  return (dispatch, getState) => {
    const timeRange = getState()[REDUCER_NAME].timeRangeFilter;
    const dateRangeOption = timeRange
      ? caculateDateByTimeFillter(timeRange)
      : getState()[REDUCER_NAME].dateRangeOption;

    const ticker = getState()[REDUCER_NAME].ticker;
    const formatParams = formatedParamsCorporate(
      params,
      ticker,
      dateRangeOption,
    );
    const finalParams = {
      ...formatParams,
      ListingTbl: params.ListingTbl,
    };
    corpotateService.getListDataLisCorporate(finalParams).then(res => {
      const [ids, data] = formatListing(res.items);
      const type =
        params.ListingTbl === NEW_LISTING
          ? LOAD_MORE_NEW_LISTING
          : LOAD_MORE_OTHER_LISTING;
      dispatch({
        type,
        payload: {
          ids,
          data,
        },
      });
    });
  };
}

function loadMoreCorporateDiv(params) {
  return (dispatch, getState) => {
    const timeRange = getState()[REDUCER_NAME].timeRangeFilter;
    const dateRangeOption = timeRange
      ? caculateDateByTimeFillter(timeRange)
      : getState()[REDUCER_NAME].dateRangeOption;

    const ticker = getState()[REDUCER_NAME].ticker;
    const currentFilterEvents = getState()[REDUCER_NAME].currentFilterEvents;
    const formatParams = formatedParamsCorporate(
      params,
      ticker,
      dateRangeOption,
    );

    let listData = [];
    dispatch(setFetching());
    if (currentFilterEvents === CorporateConst.listFilterEventByKey.div.key) {
      if (params.isCashDiv) {
        corpotateService
          .getListDataDivCashCorporate(formatParams)
          .then(response => {
            dispatch(setFetching(false));
            listData = response.items;
            dispatch({
              type: LOAD_MORE_DIV_CORPORATE,
              payload: {
                listCashDiv: listData || {},
              },
            });
          });
        dispatch({
          type: FETCH_DATA_CORPORATE,
          payload: {
            isFetchingCorporate: true,
          },
        });
      } else {
        corpotateService
          .getListDataDivStockCorporate(formatParams)
          .then(response => {
            dispatch(setFetching(false));
            listData = response.items;
            dispatch({
              type: LOAD_MORE_DIV_CORPORATE,
              payload: {
                listStockDiv: listData || {},
              },
            });
          });
        dispatch({
          type: FETCH_DATA_CORPORATE,
          payload: {
            isFetchingCorporateStock: true,
          },
        });
      }
    } else {
      if (currentFilterEvents === CorporateConst.listFilterEventByKey.ern.key) {
        corpotateService
          .getListDataErnCorporate(formatParams)
          .then(response => {
            dispatch(setFetching(false));
            listData = response.items;
            dispatch({
              type: LOAD_MORE_DIV_CORPORATE,
              payload: {
                listDataLoadmore: listData || {},
              },
            });
          });
        dispatch({
          type: FETCH_DATA_CORPORATE,
          payload: {
            isFetchingTypeCorporate: true,
          },
        });
      }

      if (currentFilterEvents === CorporateConst.listFilterEventByKey.sis.key) {
        corpotateService
          .getListDataSisCorporate(formatParams)
          .then(response => {
            dispatch(setFetching(false));
            listData = response.items;
            dispatch({
              type: LOAD_MORE_DIV_CORPORATE,
              payload: {
                listDataLoadmore: listData || {},
              },
            });
          });
        dispatch({
          type: FETCH_DATA_CORPORATE,
          payload: {
            isFetchingTypeCorporate: true,
          },
        });
      }

      if (currentFilterEvents === CorporateConst.listFilterEventByKey.ipo.key) {
        corpotateService
          .getListDataLisCorporate(formatParams)
          .then(response => {
            dispatch(setFetching(false));
            listData = response.items;
            dispatch({
              type: LOAD_MORE_DIV_CORPORATE,
              payload: {
                listDataLoadmore: listData || {},
              },
            });
          });
        dispatch({
          type: FETCH_DATA_CORPORATE,
          payload: {
            isFetchingTypeCorporate: true,
          },
        });
      }

      if (currentFilterEvents === CorporateConst.listFilterEventByKey.agm.key) {
        corpotateService
          .getListDataAgmCorporate(formatParams)
          .then(response => {
            dispatch(setFetching(false));
            listData = response.items;
            dispatch({
              type: LOAD_MORE_DIV_CORPORATE,
              payload: {
                listDataLoadmore: listData || {},
              },
            });
          });
        dispatch({
          type: FETCH_DATA_CORPORATE,
          payload: {
            isFetchingTypeCorporate: true,
          },
        });
      }
    }
  };
}

function formatListing(data) {
  const ids = [];
  const returnData = {};
  data.forEach(item => {
    const generateId = `${item.organCode}_${uniqueNumber()}`;
    ids.push(generateId);
    returnData[generateId] = item;
  });

  return [ids, returnData];
}

function fetchListDataTable() {
  return (dispatch, getState) => {
    const currentFilterEvents = getState()[REDUCER_NAME].currentFilterEvents;
    const timeRange = getState()[REDUCER_NAME].timeRangeFilter;
    let dateRangeOption = {};
    if (timeRange) {
      dateRangeOption = caculateDateByTimeFillter(timeRange);
    } else {
      dateRangeOption = getState()[REDUCER_NAME].dateRangeOption;
    }
    const { organCode } = getState()[REDUCER_NAME].currentSearch;

    let formatParams = getFormatParamByFilterSearch(organCode, dateRangeOption);
    let listData = [];

    switch (currentFilterEvents) {
      case CorporateConst.listFilterEventByKey.ern.key:
        corpotateService
          .getListDataErnCorporate(formatParams)
          .then(response => {
            listData = response.items || {};
            dispatch({
              type: FETCH_LIST_CORPORATE,
              payload: {
                listDataCorporate: listData,
                response,
              },
            });
          });
        break;

      case CorporateConst.listFilterEventByKey.div.key:
        const promises = [
          corpotateService.getListDataDivCashCorporate(formatParams),
          corpotateService.getListDataDivStockCorporate(formatParams),
        ];
        Promise.all(promises).then(([cash, stock]) => {
          dispatch({
            type: FETCH_LIST_CORPORATE,
            payload: {
              //list cash
              listDataCashDiv: cash || {},
              totalCountCash: cash.totalCount,
              //list stock
              listDataStockDiv: stock || {},
              totalCountStock: stock.totalCount,
            },
          });
        });

        break;
      case CorporateConst.listFilterEventByKey.sis.key:
        corpotateService
          .getListDataSisCorporate(formatParams)
          .then(response => {
            listData = response.items || {};
            dispatch({
              type: FETCH_LIST_CORPORATE,
              payload: {
                listDataCorporate: listData,
                response,
              },
            });
          });
        break;
      case CorporateConst.listFilterEventByKey.ipo.key:
        const newListingParams = {
          ...formatParams,
          ListingTbl: NEW_LISTING,
        };
        const otherListingParams = {
          ...formatParams,
          ListingTbl: OTHER_LISTING,
        };
        const listingPromises = [
          corpotateService.getListDataLisCorporate(newListingParams),
          corpotateService.getListDataLisCorporate(otherListingParams),
        ];
        Promise.all(listingPromises).then(([newListing, otherListing]) => {
          const [newListingIds, newListingData] = formatListing(
            newListing.items || [],
          );
          const [otherListingIds, otherListingData] = formatListing(
            otherListing.items || [],
          );
          dispatch({
            type: SET_DATA_LISTING,
            payload: {
              newListingIds,
              newListingData,
              totalPageNewListing: Math.ceil(
                newListing.totalCount / newListing.pageSize,
              ),
              otherListingIds,
              otherListingData,
              totalPageOtherListing: Math.ceil(
                otherListing.totalCount / otherListing.pageSize,
              ),
            },
          });
        });
        break;
      case CorporateConst.listFilterEventByKey.agm.key:
        corpotateService
          .getListDataAgmCorporate(formatParams)
          .then(response => {
            listData = response.items || {};
            dispatch({
              type: FETCH_LIST_CORPORATE,
              payload: {
                listDataCorporate: listData,
                response,
              },
            });
          });
        break;
      default:
        break;
    }
  };
}

function changeFilterEvent(key) {
  return (dispatch, getState) => {
    const textSearch = getState()[REDUCER_NAME].textSearch || '';

    const currentFilterEvents = getState()[REDUCER_NAME].currentFilterEvents;
    if (key !== currentFilterEvents) {
      dispatch({
        type: CHANGE_FILTER_EVENT,
        payload: {
          key,
          textSearch,
        },
      });
      dispatch(fetchListDataTable());
    }
  };
}

function getParamFromTo(key, timeRange) {
  const date = new Date();
  let start = '';
  let end = '';
  if (key === WEEK) {
    if (timeRange === CorporateConst.listTimeRangeByKey.ThisWeek.key) {
      start = moment()
        .startOf(key)
        .format('MM/DD/YYYY');
      end = moment()
        .endOf(key)
        .format('MM/DD/YYYY');
    }
    if (timeRange === CorporateConst.listTimeRangeByKey.LastWeek.key) {
      date.setDate(date.getDate() - 7);
      start = moment(date)
        .startOf(key)
        .format('MM/DD/YYYY');
      end = moment(date)
        .endOf(key)
        .format('MM/DD/YYYY');
    }
    if (timeRange === CorporateConst.listTimeRangeByKey.NextWeek.key) {
      date.setDate(date.getDate() + 7);
      start = moment(date)
        .startOf(key)
        .format('MM/DD/YYYY');
      end = moment(date)
        .endOf(key)
        .format('MM/DD/YYYY');
    }
  } else {
    if (timeRange === CorporateConst.listTimeRangeByKey.ThisMonth.key) {
      start = moment()
        .startOf(key)
        .format('MM/DD/YYYY');
      end = moment()
        .endOf(key)
        .format('MM/DD/YYYY');
    }
    if (timeRange === CorporateConst.listTimeRangeByKey.LastMonth.key) {
      date.setMonth(date.getMonth() - 1);
      start = moment(date)
        .startOf(key)
        .format('MM/DD/YYYY');
      end = moment(date)
        .endOf(key)
        .format('MM/DD/YYYY');
    }
    if (timeRange === CorporateConst.listTimeRangeByKey.NextMonth.key) {
      date.setMonth(date.getMonth() + 1);
      start = moment(date)
        .startOf(key)
        .format('MM/DD/YYYY');
      end = moment(date)
        .endOf(key)
        .format('MM/DD/YYYY');
    }
  }
  return {
    FromDate: start,
    ToDate: end,
  };
}

function caculateDateByTimeFillter(timeRange) {
  if (
    timeRange === CorporateConst.listTimeRangeByKey.ThisWeek.key ||
    timeRange === CorporateConst.listTimeRangeByKey.NextWeek.key ||
    timeRange === CorporateConst.listTimeRangeByKey.LastWeek.key
  ) {
    return getParamFromTo(WEEK, timeRange);
  }

  if (
    timeRange === CorporateConst.listTimeRangeByKey.ThisMonth.key ||
    timeRange === CorporateConst.listTimeRangeByKey.NextMonth.key ||
    timeRange === CorporateConst.listTimeRangeByKey.LastMonth.key
  ) {
    return getParamFromTo(MONTH, timeRange);
  }
}

function changeTimeRange(timeRange) {
  return (dispatch, getState) => {
    const timeRangeFilter = getState()[REDUCER_NAME].timeRangeFilter;
    let dateRangeOption = {};
    if (!timeRange) {
      dateRangeOption = getState()[REDUCER_NAME].dateRangeOption;
      dispatch({
        type: CHANGE_TIME_RANGE,
        payload: {
          timeRange,
          dateRangeOption,
        },
      });
    }
    if (timeRange && timeRange !== timeRangeFilter) {
      dateRangeOption = caculateDateByTimeFillter(timeRange);
      dispatch({
        type: CHANGE_TIME_RANGE,
        payload: {
          timeRange,
          dateRangeOption,
        },
      });
      dispatch(fetchListDataTable());
    }
  };
}

function resetDateRangeOption() {
  return dispatch => {
    dispatch({
      type: RESET_DATE_RANGE_OPTION,
      payload: {},
    });
  };
}

function setDateRangeOption(FromDate, ToDate) {
  return dispatch => {
    dispatch({
      type: SET_DATE_RANGE_OPTION,
      payload: {
        FromDate,
        ToDate,
      },
    });
    dispatch(changeTimeRange(null));
    dispatch(fetchListDataTable());
  };
}

function setFilterNewValue(filterKey, filterValue) {
  return dispatch => {
    dispatch({
      type: SET_FILTER_NEW_VALUE,
      payload: {
        filterKey,
        filterValue,
      },
    });
  };
}

function changeCode(currentSearch) {
  return dispatch => {
    dispatch({
      type: CHANGE_CODE,
      payload: {
        currentSearch,
      },
    });
    dispatch(fetchListDataTable());
  };
}

function fetchListWatchListDropDown() {
  return (dispatch, getState) => {
    marketCalendarService.getListWatchListDropDowm().then(response => {
      const { items = [] } = response;
      const store = getState();

      let idDefault = store[REDUCER_NAME_WL].watchListId;
      const watchlistIdDefault = items
        ? items.find(item => {
            return _.isEmpty(idDefault) && _.isNumber(idDefault)
              ? item.watchListId === idDefault
              : item.code === Const.VN30;
          })
        : null;

      dispatch({
        type: FETCH_LIST_WATCH_LIST_DROP,
        payload: {
          lstWatchListdrop: items,
          watchListId:
            store[REDUCER_NAME].watchListId || watchlistIdDefault.watchListId,
          watchlistType: watchlistIdDefault ? watchlistIdDefault.typeCode : '',
        },
      });
    });
  };
}

function changeTab(currentTab) {
  return dispatch => {
    dispatch({
      type: CHANGE_TAB,
      payload: {
        currentTab,
      },
    });

    fetchData(dispatch, currentTab);
  };
}

const initialState = {
  lstTickerWatchListDrop: [],
  lstTickerWatchListDropByTicker: {},
  lstTickerWatchList: [],
  listWatchListByTicker: {},
  queryNews: null,
  //corporate
  currentFilterEvents: CorporateConst.listFilterEventByKey.ern.key,
  listCashDividend: [],
  listCashDividendByTicker: {},
  listStockDividend: [],
  listStockDividendByTicker: {},
  totalPageCash: 0,
  totalPageStock: 0,
  isFetchingCorporate: false,
  isFetchingCorporateStock: false,
  responseCash: [],
  responseStock: [],
  indexListAppendCash: 0,
  indexListAppendStock: 0,
  currenPageScrollCash: 1,
  currenPageScrollStock: 1,
  currentPage: 1,
  //lis
  newListingIds: [],
  newListingData: {},
  totalPageNewListing: 0,
  currentPageNewListing: 1,
  otherListingIds: [],
  otherListingData: {},
  totalPageOtherListing: 0,
  currentPageOtherListing: 1,

  indexListAppendLoadmoreData: 0,
  currenPageScrollCoporateTypeEvent: 1,
  isFetchingTypeCorporate: false,

  //timeRange
  timeRangeFilter: CorporateConst.defaultTimeRange,
  //data corporate
  listDataCorporate: [],
  listTickerTable: [],
  listDataByTicker: {},
  currentSearch: {},

  //calendar button
  dateRangeOption: {
    FromDate: null,
    ToDate: null,
  },

  //watchlist
  currentTab: 2,
  eventType: Const.defaultEvenType,
  watchlistType: null,
  watchListId: 'watchListIdDefault',
  fromPublicDate: null,
  toPublicDate: null,
  fromExrightDate: null,
  toExrightDate: null,
  fromRecordDate: null,
  toRecordDate: null,
  fromExerciseDate: null,
  toExerciseDate: null,
  lstTickerLoadMore: [],
  lstTickerLoadMoreByTicker: {},
  isFetching: false,
  totalPage: 10,
  checkFlag: 0,
  firstPage: 0,
  page: 1,
  watchlistIdDefault: {},
  //Economy
  listTickerEconomy: [],
  listTickerEconomyByTicker: {},
  activeStatus: false,
  currentWeek: 1,
  position: moment().weekday(),
  weekOfYear: moment().week(),
  year: moment().year(),
  keyWordEconomy: '',
  filterDate: moment()
    .day(moment().weekday())
    .format('dddd, MMMM DD, YYYY'), // default get date now
  totalPageEco: 10,
  isFetchingEco: false,
  component: {},
};

const appendId = (data, indexListAppend) => {
  if (!data.length) {
    return [{}, []];
  }

  if (indexListAppend && indexListAppend.length !== 0) {
    const { list, ids } = data.reduce(
      (result, item) => {
        indexListAppend += 1;
        return {
          ids: result.ids.concat(indexListAppend),
          list: {
            ...result.list,
            [indexListAppend]: item,
          },
        };
      },
      { list: {}, ids: [] },
    );
    return [list, ids];
  } else {
    const { list, ids } = data.reduce(
      (result, item, index) => {
        return {
          ids: result.ids.concat(index + 1),
          list: {
            ...result.list,
            [index + 1]: item,
          },
        };
      },
      { list: {}, ids: [] },
    );
    return [list, ids];
  }
};

function reducer(state = {}, action) {
  let timeRangeFilter = '';

  switch (action.type) {
    case INIT_COMPONENT:
      return {
        ...state,
        ...initialState,
        watchListId: currentState.get(
          ConstCommon.listComponent.MarketCalendar,
          'watchListId',
        ),
        eventType: currentState.get(
          ConstCommon.listComponent.MarketCalendar,
          'eventType',
        ),
      };

    case UNMOUNT_COMPONENT:
      return {};

    case SET_QUERY_NEW_VALUE:
      const { queryNews } = action.payload;
      return {
        ...state,
        queryNews,
      };

    case CHANGE_CODE:
      return {
        ...state,
        ...action.payload,
      };

    case CHANGE_FILTER_EVENT:
      timeRangeFilter = { ...state }.timeRangeFilter;
      if (action.payload.key === CorporateConst.listFilterEventByKey.ern.key) {
        timeRangeFilter = CorporateConst.listTimeRangeByKey.ThisWeek.key;
      } else {
        timeRangeFilter = CorporateConst.listTimeRangeByKey.ThisMonth.key;
      }
      dateRangeOption = {
        FromDate: null,
        ToDate: null,
      };

      return {
        ...state,
        currentFilterEvents: action.payload.key,
        timeRangeFilter: timeRangeFilter,
        textSearch: action.payload.textSearch,
        dateRangeOption: dateRangeOption,
        currentPage: 1,
      };

    case CHANGE_TIME_RANGE:
      timeRangeFilter = action.payload.timeRange;
      return {
        ...state,
        timeRangeFilter,
        dateRangeOption: action.payload.dateRangeOption,
      };

    case LOAD_MORE_DIV_CORPORATE:
      let { listCashDiv, listStockDiv, listDataLoadmore } = action.payload;

      if (listDataLoadmore) {
        const [listDataByTicker, listTickerTable] = appendId(
          listDataLoadmore,
          state.indexListAppendLoadmoreData,
        );
        return {
          ...state,
          listTickerTable: [...state.listTickerTable, ...listTickerTable],
          listDataByTicker: {
            ...state.listDataByTicker,
            ...listDataByTicker,
          },
          indexListAppendLoadmoreData:
            state.indexListAppendLoadmoreData + listTickerTable.length,
          isFetchingTypeCorporate: false,
          currenPageScrollCoporateTypeEvent: (state.currenPageScrollCoporateTypeEvent += 1),
        };
      }

      if (!listStockDiv) {
        if (listCashDiv) {
          const [listCashDividendByTicker, listCashDividend] = appendId(
            listCashDiv,
            state.indexListAppendCash,
          );
          return {
            ...state,
            listCashDividend: [...state.listCashDividend, ...listCashDividend],
            listCashDividendByTicker: {
              ...state.listCashDividendByTicker,
              ...listCashDividendByTicker,
            },
            indexListAppendCash:
              state.indexListAppendCash + listCashDividend.length,
            isFetchingCorporate: false,
            currenPageScrollCash: (state.currenPageScrollCash += 1),
          };
        }
      }

      if (!listCashDiv) {
        if (listStockDiv) {
          const [listStockDividendByTicker, listStockDividend] = appendId(
            listStockDiv,
            state.indexListAppendStock,
          );

          return {
            ...state,
            listStockDividend: [
              ...state.listStockDividend,
              ...listStockDividend,
            ],
            listStockDividendByTicker: {
              ...state.listStockDividendByTicker,
              ...listStockDividendByTicker,
            },
            indexListAppendStock:
              state.indexListAppendStock + listStockDividend.length,
            isFetchingCorporateStock: false,
            currenPageScrollStock: (state.currenPageScrollStock += 1),
          };
        }
      }
      return state;

    case FETCH_DATA_CORPORATE:
      const {
        isFetchingCorporate,
        isFetchingCorporateStock,
        isFetchingTypeCorporate,
      } = action.payload;
      if (isFetchingCorporate) {
        return {
          ...state,
          isFetchingCorporate,
        };
      }

      if (isFetchingTypeCorporate) {
        return {
          ...state,
          isFetchingTypeCorporate,
        };
      }

      if (isFetchingCorporateStock) {
        return {
          ...state,
          isFetchingCorporateStock,
        };
      }
      return state;

    case FETCH_LIST_CORPORATE:
      let data = action.payload.listDataCorporate;
      const pageSize = 50;
      if (!data) {
        // if (typeof data === 'object' && !Array.isArray(data)) {
        //const [listCashDividendByTicker, listCashDividend] = appendId(data.cashDividend)
        const { totalCountCash, totalCountStock } = action.payload;
        const totalPageCash = Math.ceil(totalCountCash / pageSize);
        const totalPageStock = Math.ceil(totalCountStock / pageSize);

        if (
          action.payload.listDataCashDiv.items &&
          action.payload.listDataStockDiv.items
        ) {
          const [listCashDividendByTicker, listCashDividend] = appendId(
            action.payload.listDataCashDiv.items,
          );
          const [listStockDividendByTicker, listStockDividend] = appendId(
            action.payload.listDataStockDiv.items,
          );

          let indexListAppendCash = 0;
          let indexListAppendStock = 0;
          if (listCashDividend) {
            indexListAppendCash = listCashDividend.length;
          }
          if (listStockDividend) {
            indexListAppendStock = listStockDividend.length;
          }

          return {
            ...state,
            listCashDividend,
            listCashDividendByTicker,

            totalPageCorporateDiv: action.payload.totalPageCorporateDiv,
            indexListAppendCash: indexListAppendCash,

            listStockDividend,
            listStockDividendByTicker,

            totalPageCorporateDivStock:
              action.payload.totalPageCorporateDivStock,
            indexListAppendStock: indexListAppendStock,

            totalPageCash: totalPageCash,
            totalPageStock: totalPageStock,

            currenPageScrollCash: 1,
            currenPageScrollStock: 1,
          };
        }
      }

      if (data) {
        const { response } = action.payload;
        const [listDataByTicker, listTickerTable] = appendId(data);
        const totalPage = Math.ceil(response.totalCount / pageSize);

        let indexListAppendLoadmoreData = 0;
        if (listTickerTable) {
          indexListAppendLoadmoreData = listTickerTable.length;
        }
        return {
          ...state,
          listDataCorporate: data,
          listTickerTable: listTickerTable,
          listDataByTicker: listDataByTicker,
          currenPageScrollCoporateTypeEvent: 1,
          totalPageCoporateTypeEvent: totalPage,
          indexListAppendLoadmoreData,
        };
      }
      return state;

    case SET_DATE_RANGE_OPTION:
      const { FromDate, ToDate } = action.payload;
      let dateRangeOption = {
        FromDate,
        ToDate,
      };

      return {
        ...state,
        dateRangeOption,
      };

    case RESET_DATE_RANGE_OPTION:
      return {
        ...state,
        dateRangeOption: {
          FromDate: null,
          ToDate: null,
        },
      };

    case SET_FILTER_NEW_VALUE:
      const { filterKey, filterValue } = action.payload;
      const filterOption = {
        ...state.filterValue,
        filterKey,
        filterValue,
      };
      return {
        ...state,
        filterOption,
      };

    case FETCH_LIST_WATCH_LIST: {
      const { lstWatchList, totalCount, pageSize } = action.payload;

      const totalPage = Math.ceil(totalCount / pageSize);
      const lstTickerWatchList = lstWatchList.map(
        item => item[Const.listId.eventId],
      );
      const listWatchListByTicker = _.keyBy(lstWatchList, Const.listId.eventId);

      return {
        ...state,
        lstTickerWatchList,
        listWatchListByTicker,
        totalPage,
        page: 1,
      };
    }

    case LOAD_MORE_WATCH_LIST: {
      const { listWatchListLoadMore, pageNumber } = action.payload;
      const lstTickerLoadMore = listWatchListLoadMore.map(item =>
        getDataFollowKeyByDot(item, Const.listId.eventId),
      );
      const lstTickerLoadMoreByTicker = _.keyBy(
        listWatchListLoadMore,
        Const.listId.eventId,
      );
      return {
        ...state,
        lstTickerWatchList: [...state.lstTickerWatchList, ...lstTickerLoadMore],
        listWatchListByTicker: {
          ...state.listWatchListByTicker,
          ...lstTickerLoadMoreByTicker,
        },
        isFetching: false,
        firstPage: 0,
        page: pageNumber,
      };
    }

    case FETCH_LIST_WATCH_LIST_DROP: {
      const { lstWatchListdrop, watchListId, watchlistType } = action.payload;
      let lstTickerWatchListDrop = [];
      let lstTickerWatchListDropByTicker = {};
      if (lstWatchListdrop) {
        lstTickerWatchListDrop = lstWatchListdrop.map(item =>
          getDataFollowKeyByDot(item, Const.listId.watchListId),
        );
        lstTickerWatchListDropByTicker = _.keyBy(
          lstWatchListdrop,
          Const.listId.watchListId,
        );
      }

      return {
        ...state,
        watchListId,
        watchlistType,
        lstTickerWatchListDrop,
        lstTickerWatchListDropByTicker,
      };
    }

    case CHANGE_EVENT_TYPE: {
      const { eventType, watchListId, watchlistType } = action.payload;

      currentState.add(
        ConstCommon.listComponent.MarketCalendar,
        'eventType',
        eventType,
      );

      // console.log(eventType)

      // const eventTypeCustom = eventType !== "IPO" ? eventType : "LIS"

      return {
        ...state,
        // eventType: eventTypeCustom,
        eventType,
        watchListId,
        watchlistType,
        checkFlag: 1,
        firstPage: 1,
      };
    }

    case CHANGE_WATCH_LIST: {
      const { watchListId, watchlistType, eventType } = action.payload;

      currentState.add(
        ConstCommon.listComponent.MarketCalendar,
        'watchListId',
        watchListId,
      );

      return {
        ...state,
        watchlistType,
        watchListId,
        eventType,
        checkFlag: 2,
        firstPage: 1,
      };
    }

    case CHANGE_GET_DATA: {
      const {
        fromPublicDate,
        toPublicDate,
        fromExrightDate,
        toExrightDate,
        fromRecordDate,
        toRecordDate,
        fromExerciseDate,
        toExerciseDate,
      } = action.payload;

      return {
        ...state,
        fromPublicDate,
        toPublicDate,
        fromExrightDate,
        toExrightDate,
        fromRecordDate,
        toRecordDate,
        fromExerciseDate,
        toExerciseDate,
        checkFlag: 3,
        firstPage: 1,
      };
    }

    case FETCH_DATA:
      const { isFetching } = action.payload;
      return {
        ...state,
        isFetching,
      };

    case FETCH_DATA_ECO:
      const { isFetchingEco } = action.payload;
      return {
        ...state,
        isFetchingEco,
      };

    case CHANGE_FLAG:
      const { checkFlag } = action.payload;
      return {
        ...state,
        checkFlag,
      };

    case FETCH_LIST_WATCH_LIST_DATE: {
      const {
        fromPublicDate,
        toPublicDate,
        fromExrightDate,
        toExrightDate,
        fromRecordDate,
        toRecordDate,
        fromExerciseDate,
        toExerciseDate,
      } = action.payload;

      return {
        ...state,
        fromPublicDate,
        toPublicDate,
        fromExrightDate,
        toExrightDate,
        fromRecordDate,
        toRecordDate,
        fromExerciseDate,
        toExerciseDate,
      };
    }

    case FETCH_LIST_ECONOMY: {
      const { listEconomy, totalCount } = action.payload;
      const totalPageEco = Math.ceil(totalCount / ConstEconomy.pageSize);
      const listTickerEconomy = listEconomy.map(item =>
        getDataFollowKeyByDot(item, ConstEconomy.ids.sortOrder),
      );
      const listTickerEconomyByTicker = _.keyBy(
        listEconomy,
        ConstEconomy.ids.sortOrder,
      );
      return {
        ...state,
        listTickerEconomy,
        listTickerEconomyByTicker,
        totalPageEco,
      };
    }

    case SET_FILTER_ECONOMY_VALUE: {
      const { filterKey, filterValue } = action.payload;
      const filterOption = {
        ...state.filterValue,
        filterKey,
        filterValue,
      };
      return {
        ...state,
        filterOption,
      };
    }

    case SET_ACTIVE_DAY_IN_WEEK_CHANGE_TAB: {
      const { activeStatus } = action.payload;
      return {
        ...state,
        activeStatus,
      };
    }

    case LIST_ECO_BY_CHECKBOX: {
      const { listEcoNew } = action.payload;
      const listTickerEconomy = listEcoNew.map(item =>
        getDataFollowKeyByDot(item, ConstEconomy.ids.sortOrder),
      );
      const listTickerEconomyByTicker = _.keyBy(
        listEcoNew,
        ConstEconomy.ids.sortOrder,
      );
      return {
        ...state,
        listTickerEconomy,
        listTickerEconomyByTicker,
      };
    }

    case SET_ACTIVE_DAY_IN_WEEK: {
      const {
        activeStatus,
        currentWeek,
        position,
        filterDate,
      } = action.payload;
      return {
        ...state,
        activeStatus,
        currentWeek,
        position,
        filterDate,
      };
    }

    case SET_PARAMS_ECO: {
      const { weekOfYear, year, keyWord } = action.payload;
      return {
        ...state,
        weekOfYear,
        year,
        keyWordEconomy: keyWord,
      };
    }

    case CHANGE_SIZE_COMPONENT:
      return {
        ...state,
        component: action.payload,
      };

    case SET_DATA_LISTING:
      return {
        ...state,
        ...action.payload,
      };

    case LOAD_MORE_NEW_LISTING:
      return {
        ...state,
        newListingIds: state.newListingIds.concat(action.payload.ids),
        newListingData: {
          ...state.newListingData,
          ...action.payload.data,
        },
      };
    case LOAD_MORE_OTHER_LISTING:
      return {
        ...state,
        otherListingIds: state.otherListingIds.concat(action.payload.ids),
        otherListingData: {
          ...state.otherListingData,
          ...action.payload.data,
        },
      };
    default:
      return state;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
